import { AppStartListening } from 'store/listenerMiddleware';
import {
  selectHandRaisedNotification,
  selectNotificationById,
  selectNotificationsByScope,
} from 'features/notifications/notificationsSlice';
import { WAITING_ENTRY_NOTIFICATION_ID } from 'features/notifications/constants';
import { selectPinnedPanels, selectSidePanel } from 'features/side-panels/sidePanelsSlice';
import { SidePanelType } from 'features/side-panels/types';
import { updateActionNotification } from 'features/notifications/action-notifications/updateActionNotification';

export const panelChangeListener = (startListening: AppStartListening) =>
  startListening({
    predicate: (action, currentState, originalState) => {
      const originalPanel = selectSidePanel(originalState);
      const currentPanel = selectSidePanel(currentState);
      const originalPinned = selectPinnedPanels(originalState);
      const currentPinned = selectPinnedPanels(currentState);

      return currentPanel !== originalPanel || currentPinned !== originalPinned;
    },
    effect: (action, { dispatch, getState }) => {
      const state = getState();

      const activePanel = selectSidePanel(state);
      const pinnedPanels = selectPinnedPanels(state);

      const isPanelVisible = (type: SidePanelType) =>
        activePanel === type || pinnedPanels.includes(type);

      // waiting notification
      const waitingEntryNotification = selectNotificationById(state, WAITING_ENTRY_NOTIFICATION_ID);
      if (waitingEntryNotification) {
        dispatch(
          updateActionNotification(WAITING_ENTRY_NOTIFICATION_ID, {
            hideOkAction: isPanelVisible('users'),
          })
        );
      }

      // hand raised notification
      const handRaisedNotification = selectHandRaisedNotification(state);
      if (handRaisedNotification) {
        dispatch(
          updateActionNotification(handRaisedNotification.id, {
            hideOkAction: isPanelVisible('users'),
          })
        );
      }

      // live answer notification
      const liveAnswerNotifications = selectNotificationsByScope(state, 'qa');
      liveAnswerNotifications.forEach((id) => {
        const notification = selectNotificationById(state, id);
        if (notification) {
          dispatch(
            updateActionNotification(id, {
              hideOkAction: isPanelVisible('qa'),
            })
          );
        }
      });
    },
  });
